import { checkThirdParty } from '@atlassian/browser-storage-controls';
import { isAtlThirdPartyLoaderAvailable } from '@trello/storage';

const loadScript = (
  url: string,
  attributes: Record<string, string> = {},
): Promise<void> => {
  // eslint-disable-next-line @trello/no-query-selector
  const head = document.querySelector('head');
  if (head) {
    return new Promise((resolve, reject) => {
      const scriptEl = document.createElement('script');
      scriptEl.async = true;
      scriptEl.src = url;
      scriptEl.onload = () => resolve();
      scriptEl.onerror = reject;
      Object.entries(attributes).forEach(([key, value]) => {
        scriptEl.setAttribute(key, value);
      });

      return head.appendChild(scriptEl);
    });
  } else {
    return Promise.reject('No head found');
  }
};

/**
 * Loads a third party script with optional attributes.
 * If the script is allowed by the browser storage controls, it will be loaded.
 * Otherwise, it will be rejected.
 *
 * @param name: string - The name of the script to load.
 * @param url: string - The URL of the script to load.
 * @param attributes: Record<string, string> - The attributes to add to the script element.
 * @returns A promise that resolves when the script is loaded.
 */
export const loadThirdPartyScript = (
  name: string,
  url: string,
  attributes: Record<string, string> = {},
): Promise<void> => {
  const onAllowed = () => {
    return loadScript(url, attributes);
  };

  const onDenied = () => {
    console.warn('Third party script denied', url);
    return Promise.reject('Third party script denied');
  };

  // TODO: remove this check for gate cleanup: tplat_atl_third_party_loader, and the reference to storage from tsconfig
  if (isAtlThirdPartyLoaderAvailable()) {
    console.warn('Checking third party script', url);
    return checkThirdParty(name, onAllowed, onDenied);
  } else {
    return onAllowed();
  }
};
